import { memo, useCallback } from 'react';

import { cx } from '@/utils/cx';

import { ApproveAllControl } from './ProposalListBulkActions';
import type { PriorityGroup } from './utils/groupProposalsByTier';

interface GroupTrailingControlsProps {
  group: PriorityGroup;
  approvingTier: string | null;
  /** True while any rows are selected — the whole-group controls hide
      (visibility, not unmount, so the header never reflows) because the
      selection toolbar's Approve/Dismiss own bulk actions in that mode;
      two near-identical stacked control rows invite scope mis-clicks. */
  selectionActive: boolean;
  onApprove: (group: PriorityGroup) => void;
  onDismiss: (group: PriorityGroup) => void;
}

// Group headers act on the WHOLE group with static labels — selection-scoped
// bulk actions live in the selection toolbar instead. Rendered into the
// GroupedList section header's `trailing` slot.
export const GroupTrailingControls = memo(function GroupTrailingControls({
  group,
  approvingTier,
  selectionActive,
  onApprove,
  onDismiss,
}: GroupTrailingControlsProps) {
  const handleApprove = useCallback(() => {
    onApprove(group);
  }, [onApprove, group]);

  const handleDismiss = useCallback(() => {
    onDismiss(group);
  }, [onDismiss, group]);

  return (
    <div className={cx('shrink-0', selectionActive && 'invisible')}>
      <ApproveAllControl
        onApprove={handleApprove}
        onDismiss={handleDismiss}
        disabled={approvingTier !== null}
      />
    </div>
  );
});
